module.exports = __webpack_public_path__ + "media/images/icon__copy-to-clipboard-243165557fab54c2bb33940e546f1543.png";